import { makeStyles } from '@material-ui/core'

const useStylesSkeleton = makeStyles({
  root2: {
    background: '#c9c9c9',
    borderRadius: 5 
  }
})

export default useStylesSkeleton